import React, { createContext, useState } from 'react';

// Create the DrawerContext
export const DrawerContext = createContext();

export const DrawerProvider = ({ children }) => {
  const [drawerWidth, setDrawerWidth] = useState(300); // Default drawer width

  return (
    <DrawerContext.Provider value={{ drawerWidth, setDrawerWidth }}>
      {children}
    </DrawerContext.Provider>
  );
};
